module.exports = __webpack_public_path__ + "img/okinawa.2b1f9fff.png";